export enum TRACK_PREVIEW_TYPES {
  FULL = 'FULL',
  PREVIEW_30 = 'PREVIEW_30',
}

export const isTrackShortPreviewEnabled = (track) => {
  return track.previewType === TRACK_PREVIEW_TYPES.PREVIEW_30;
};
